import { UseQueryResult } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

export const useQueriesProgress = <T,>(
  queries: UseQueryResult<T | undefined, unknown>[]
) => {
  const [progress, setProgress] = useState<number>(0)

  useEffect(() => {
    if (queries?.length > 0) {
      const nrOfQueries = queries.length

      const completedQueries = queries.filter(
        (response) => !response.isLoading && !response.isFetching
      ).length

      const fetchProgress = completedQueries / nrOfQueries

      setProgress(fetchProgress)
    }
  }, [queries])

  return progress
}
